import {
  SET_COURSE_OUTLINE,
  GET_COURSE_OUTLINE,
  RESET_COURSE_OUTLINE,
} from 'legacy/src/constants/types';

export function getCourseOutline(loading) {
  return (dispatch) => {
    dispatch({ type: GET_COURSE_OUTLINE, payload: { loading } });
  };
}

export default function setCourseOutline({ subject, courseOutline }) {
  return (dispatch) => {
    dispatch({
      type: SET_COURSE_OUTLINE,
      payload: courseOutline,
      subject,
    });
  };
}

export function resetCourseOutline(dispatch) {
  dispatch({
    type: RESET_COURSE_OUTLINE,
  });
}
